export enum BsAction {
  Buy = 'buy',
  Bid = 'bid',
  Sell = 'sell',
  Ask = 'ask',
  AskUpdate = 'ask update',
  BidUpdate = 'bid update',
}
